import React from 'react'
import { Container } from 'react-bootstrap'
import Banner from '../../components/Banner'
import darkCamera from '../../assets/dark-camera.jpg'
import Items from './items/Items'
import ShipingPayment from '../../components/shippingPayment/ShipingPayment'
import Newsletter from '../../components/newsletter/Newsletter'

const CartPage = () => {
  return (
    <div className='page-wrapper bg-light'>
      <Banner img={darkCamera}>
        <h1 className='display-5 '>Cart<span className='text-danger fw-bold'>.</span></h1>

      </Banner>
      <Container>
        
        <Items />
        <ShipingPayment />
        <Newsletter />
      </Container>
    </div>
  )
}

export default CartPage